import React from "react"

import globalStyles from "../../../../App.module.scss"

export default function BashHistory() {
    return (
        <div className={globalStyles.article}>
            <h1>History tricks</h1>

            <h3>Recall shortcuts</h3>
            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '450px'}}>
                    <thead>
                    <tr>
                        <th>Shortcut</th>
                        <th>Meaning</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>!!</code></td>
                        <td>Re-run the previous command</td>
                    </tr>
                    <tr>
                        <td><code>sudo !!</code></td>
                        <td>Re-run the previous command with sudo — the classic fix for "permission denied"</td>
                    </tr>
                    <tr>
                        <td><code>{"!$"}</code></td>
                        <td>Last argument of the previous command</td>
                    </tr>
                    <tr>
                        <td><code>{"!^"}</code></td>
                        <td>First argument of the previous command</td>
                    </tr>
                    <tr>
                        <td><code>{"!*"}</code></td>
                        <td>All arguments of the previous command</td>
                    </tr>
                    <tr>
                        <td><code>!ssh</code></td>
                        <td>Re-run the most recent command starting with <code>ssh</code></td>
                    </tr>
                    <tr>
                        <td><code>{"^foo^bar"}</code></td>
                        <td>Re-run the previous command with <code>foo</code> replaced by <code>bar</code></td>
                    </tr>
                    <tr>
                        <td><code>Ctrl+R</code></td>
                        <td>Reverse-search history interactively</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Controlling what gets saved</h3>
            <pre className={globalStyles.code}>
                <code>
                    export HISTCONTROL=ignoredups:ignorespace<br/>
                    <span style={{opacity: 0.7}}># ignoredups: skip immediate duplicate entries</span><br/>
                    <span style={{opacity: 0.7}}># ignorespace: skip commands starting with a space</span><br/>
                    <br/>
                    export HISTSIZE=10000&nbsp;&nbsp;<span style={{opacity: 0.7}}># entries kept in memory</span><br/>
                    export HISTFILESIZE=20000&nbsp;&nbsp;<span style={{opacity: 0.7}}># entries kept on disk</span>
                </code>
            </pre>

            <h3>Inspecting & editing history</h3>
            <pre className={globalStyles.code}>
                <code>
                    history | grep rsync<br/>
                    history -c&nbsp;&nbsp;<span style={{opacity: 0.7}}># clear current session's history</span><br/>
                    fc -e vim -1&nbsp;&nbsp;<span style={{opacity: 0.7}}># open the last command in $EDITOR before running it</span>
                </code>
            </pre>
        </div>
    )
}
